import React, { PropTypes, Component } from 'react';
import { Field } from 'redux-form';
import idx from 'idx';
import {
  TextInputField, ColorPickerField, RadioButtonField, FileSelectorField
} from 'common/components/form_fields';
import ModalDialog from 'common/components/modal/modal_dialog';
import VotePreview from 'presentations/components/vote_preview';
import { STANDARD_PRIMARY_COLOR } from 'presentations/constants';

export default class AddStepCustomization extends Component {
  constructor(props) {
    super(props);

    this.state = { votePreviewFull: false };
    this.toggleFullVotePreview = this.toggleFullVotePreview.bind(this);
  }

  toggleFullVotePreview() {
    this.setState({ votePreviewFull: !this.state.votePreviewFull });
  }

  renderVotePreview() {
    const { values } = this.props;

    return (
      <VotePreview logo={idx(values, _ => _.logo.preview)}
        primaryColor={values.use_standard_colors? undefined : values.custom_primary_color} />
    );
  }

  render() {
    const { values } = this.props;
    const { votePreviewFull } = this.state;

    return (
      <div className="add-step-customization">
        <div className="row columns">
          <h2>Customization</h2>
        </div>

        <div className="row">
          <div className="columns large-6 small-16">
            <fieldset>
              <h3>Allow Scoring/Comments?</h3>
              <Field name="permissions" component={RadioButtonField}
                props={{ value: 'voting_and_comments' }}
                label="Allow scoring & comments."
              />
              <Field name="permissions" component={RadioButtonField}
                props={{ value: 'voting' }}
                label="Allow scoring only."
              />
              <Field name="permissions" component={RadioButtonField}
                props={{ value: 'comments' }}
                label="Allow comments only."
              />
              <Field name="permissions" component={RadioButtonField}
                props={{ value: 'nothing' }}
                label="No scoring or comments."
              />
            </fieldset>

            <fieldset>
              <h3>Add Your Logo</h3>
              <p>500 X 500 square PNG or JPG</p>
              <Field name="logo" component={FileSelectorField} withPreview={true}
                acceptedFileType="image/jpg,image/jpeg,image/png" minImageWidth={400}
                minImageHeight={400} />
            </fieldset>

            <fieldset>
              <h3>Color Scheme</h3>
              <div className="standard-color-preview" style={{ background: STANDARD_PRIMARY_COLOR }} />
              <Field name="use_standard_colors" component={RadioButtonField}
                props={{ value: true }}
                label="Standard"
              />
              <Field name="use_standard_colors" component={RadioButtonField}
                props={{ value: false }}
                label="Custom"
              />
              { !values.use_standard_colors &&
              <Field name="custom_primary_color" component={ColorPickerField} /> }
            </fieldset>
          </div>
          <div className="columns large-10 small-16 preview-wrapper">
            <h3>Preview</h3>
            <ModalDialog modalOpen={votePreviewFull} closeAction={this.toggleFullVotePreview}
                modalHeader="Preview" dialogClasses="vote-preview-modal" contentClasses="wide"
                onPrimary={this.toggleFullVotePreview} primaryLabel="Done">
              { this.renderVotePreview() }
            </ModalDialog>
            { this.renderVotePreview() }
          </div>
        </div>
      </div>
    );
  }
}

AddStepCustomization.propTypes = {
  values: PropTypes.object.isRequired,
};



// WEBPACK FOOTER //
// ./presentations/components/add_step_customization.jsx